<template>
  <div>
    <div
      class="toggle"
      v-bind:class="{ 'toggle--local': currentlyActive === 'local', 'toggle--global': currentlyActive === 'global' }">
      <div
        class="toggle__label toggle__label--global"
        @click.prevent="globalNav">
        Global
      </div>
      <div
        class="toggle__label toggle__label--local"
        @click.prevent="localNav">
        Surrey
      </div>
    </div>
  </div>


</template>
<script>
  export default {
    name: 'TopLevelNav',
    data() {
      return {
        currentlyActive: 'global',
        timer: null,
      };
    },
    mounted() {
      this.currentlyActive = this.$route.name.split('.')[0];
    },
    destroyed() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    methods: {
      localNav() {
        if (this.currentlyActive !== 'local') {
          this.setNav('local');
        }
      },
      globalNav() {
        if (this.currentlyActive !== 'global') {
          this.setNav('global');
        }
      },
      toggleNav() {
        if (this.currentlyActive === 'local') {
          this.setNav('global');
        } else {
          this.setNav('local');
        }
      },
      setNav(section) {
        this.currentlyActive = section;
        this.timer = setTimeout(() => {
          this.$router.push({ name: this.currentlyActive });
        }, 250);
      },
    },
  };
</script>
<style lang="scss" scoped>
  @import '../main.scss';
  .toggle {
    position: relative;
    cursor: pointer;
    margin: 1.6rem;
    background: $appBody;
    color: $appPrimary;
    border-radius: 16px;
    height: 32px;
  }

  .toggle:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width :50%;
    bottom: 0;
    background: $appPrimary;
    border-radius: 16px;
    transform: translateX(0);
    transition: transform 0.25s $standardEasing;
  }

  .toggle__label {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 50%;
    font-size: 1.4rem;
    text-decoration: none;
    font-weight: 400;
    transition: color 0.25s $standardEasing;
  }

  .toggle__label--local {
    left: auto;
    right: 0;
  }

  .toggle--global .toggle__label--global, .toggle--local .toggle__label--local{
    color: $appBody;
  }

  .toggle--global:before {
    transform: translateX(0);
  }

  .toggle--local:before {
    transform: translateX(100%);
  }
</style>



// WEBPACK FOOTER //
// src/components/TopLevelNav.vue